export const noop = (): void => {
	/* noop */
};

export const promiseNoop = (): Promise<void> => Promise.resolve(/* noop */);
